/**
 * BFCM product page (sale design):
 * - Keeps the "Add to cart - $X" total on the main Add to cart button in step with the quantity and the
 *   selected variant (snippets/buy-buttons.liquid, bfcm_total).
 * - Keeps one accordion item open at a time where the browser doesn't do it for details sharing a name.
 * - Scrolls the gallery's thumbnail strip so the selected thumbnail and its neighbours are in view.
 * - Centres the label of Klaviyo's "Get Early Access" teaser in its vertical tab on phones and tablets.
 *
 * Add to cart total:
 * The total is the line's regular price (data-regular-price, in cents, times the quantity) minus the
 * discount (data-percent), rounded once for the whole line as the cart's percentage discount does.
 * The money format is read from a sample amount the store formatted (data-money-sample = 123456789
 * cents), so the total looks like every other price in the store's currency.
 * Listeners sit on the document, so sections re-rendered in the theme editor keep working.
 */
(function () {
  if (window.bfcmProductTotal) return;
  window.bfcmProductTotal = true;

  // Money formats can contain entities such as &euro;
  function decodeEntities(text) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  function formatMoney(cents, sample) {
    var parts = decodeEntities(String(sample || '').replace(/<[^>]*>/g, '')).match(/^(\D*)(\d[\d\D]*\d)(\D*)$/);
    if (!parts) return (cents / 100).toFixed(2);
    // "1,234,567.89" → 2 decimals, "." decimal mark, "," thousands mark; "1,234,568" → no decimals
    var separators = parts[2].replace(/\d/g, '');
    var decimals = parts[2].replace(/\D/g, '').length === 9 ? 2 : 0;
    var decimalMark = decimals ? separators.slice(-1) : '';
    var thousandsMark = (decimals ? separators.slice(0, -1) : separators).charAt(0);
    var fixed = (cents / 100).toFixed(decimals).split('.');
    var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    return parts[1] + whole + (decimals ? decimalMark + fixed[1] : '') + parts[3];
  }

  // The quantity typed or chosen, or null while there is none to go by (no quantity field, or it's empty or 0):
  // the label then keeps the last total, e.g. the minimum quantity's total Shopify rendered
  function quantityOf(section) {
    var input = section.querySelector('.quantity__input');
    var qty = input ? parseInt(input.value, 10) : NaN;
    return qty > 0 ? qty : null;
  }

  // Rewrites the total only when the quantity differs from the one it shows (data-quantity), or when forced
  // after a variant change, so the price rendered by Shopify (and any currency app's conversion) stays as is
  function update(section, force) {
    var total = section && section.querySelector('[id^="ProductSubmitButton-"] .bfcm-atc-total');
    if (!total) return;
    var regular = parseInt(total.dataset.regularPrice, 10);
    var percent = parseFloat(total.dataset.percent);
    var qty = quantityOf(section);
    if (isNaN(regular) || isNaN(percent) || qty === null) return;
    if (!force && total.dataset.quantity === String(qty)) return;
    total.dataset.quantity = qty;
    var line = regular * qty;
    // The store's money format wraps amounts in a .money span (currency converter app): keep it
    var amount = total.querySelector('.money') || total;
    amount.textContent = formatMoney(line - Math.round((line * percent) / 100), total.dataset.moneySample);
  }

  ['change', 'input'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.matches && event.target.matches('product-info .quantity__input')) {
        update(event.target.closest('product-info'));
      }
    });
  });

  // A variant change resets the button label to "Add to cart" (product-form.js); bring back the
  // label with the new variant's sale price from the freshly rendered section.
  // A quick-add window (e.g. related products) publishes the same section id as the page's product, so the
  // target is the product-info with that section id AND the same product.
  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html) return;
    var freshInfo = data.html.querySelector('product-info[data-product-id]');
    var productId = freshInfo && freshInfo.dataset.productId;
    var section = Array.prototype.find.call(document.querySelectorAll('product-info'), function (info) {
      var sectionId = info.dataset.originalSection || info.dataset.section;
      return sectionId === String(data.sectionId) && (!productId || info.dataset.productId === productId);
    });
    if (!section) return;
    // After the gallery has switched to the variant's image (its own variant listener)
    setTimeout(function () {
      revealActiveThumbs(section);
    }, 0);
    var button = section.querySelector('[id^="ProductSubmitButton-"]');
    var fresh = (freshInfo || data.html).querySelector('[id^="ProductSubmitButton-"]');
    if (!button || !fresh || fresh.hasAttribute('disabled') || button.hasAttribute('disabled')) return;
    var label = button.querySelector('span');
    var freshLabel = fresh.querySelector('span');
    if (!label || !freshLabel || !freshLabel.querySelector('.bfcm-atc-total')) return;
    label.innerHTML = freshLabel.innerHTML;
    update(section, true);
  }

  // Accordion: the items share a details name (exclusive accordion); older browsers ignore it
  if (!('name' in HTMLDetailsElement.prototype)) {
    document.addEventListener(
      'toggle',
      function (event) {
        var details = event.target;
        var name = details instanceof HTMLDetailsElement && details.open && details.getAttribute('name');
        if (!name || !details.closest('.bfcm-pdp')) return;
        document.querySelectorAll('details[name]').forEach(function (other) {
          if (other !== details && other.getAttribute('name') === name) other.open = false;
        });
      },
      true
    );
  }

  // Gallery: the thumbnail strip scrolls (4 at a time below 1024px, a column as tall as the image above);
  // bring the selected thumbnail and the ones either side of it into view, scrolling only the strip
  function revealActiveThumbs(scope, instant) {
    (scope || document).querySelectorAll('.custom-gallery--bfcm-design .custom-gallery__thumb.is-active').forEach(function (thumb) {
      var strip = thumb.parentElement;
      var row = getComputedStyle(strip).flexDirection.indexOf('row') === 0;
      var visible = row ? strip.clientWidth : strip.clientHeight;
      if ((row ? strip.scrollWidth : strip.scrollHeight) <= visible + 1) return;
      var current = row ? strip.scrollLeft : strip.scrollTop;
      var stripStart = strip.getBoundingClientRect()[row ? 'left' : 'top'];
      var edges = function (el) {
        var rect = el.getBoundingClientRect();
        var start = (row ? rect.left : rect.top) - stripStart + current;
        return [start, start + (row ? rect.width : rect.height)];
      };
      var first = edges(thumb.previousElementSibling || thumb)[0];
      var last = edges(thumb.nextElementSibling || thumb)[1];
      var target = current;
      if (last > current + visible) target = last - visible;
      if (first < target) target = first;
      if (Math.abs(target - current) < 1) return;
      var options = { behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' };
      options[row ? 'left' : 'top'] = target;
      strip.scrollTo(options);
    });
  }

  // The gallery's own click listener (on the thumbnail) has already marked it active
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest && event.target.closest('.custom-gallery--bfcm-design .custom-gallery__thumb');
    if (thumb) revealActiveThumbs(thumb.closest('.custom-gallery'));
  });

  function updateAll() {
    document.querySelectorAll('product-info').forEach(function (section) {
      update(section);
    });
  }

  function subscribeToVariants() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    // Quantity rules can reset the quantity without a change event
    subscribe(PUB_SUB_EVENTS.quantityUpdate, updateAll);
    return true;
  }

  if (!subscribeToVariants()) {
    document.addEventListener('DOMContentLoaded', subscribeToVariants, { once: true });
  }

  updateAll();
  // A variant link can open the page on an image further down the strip
  window.addEventListener(
    'load',
    function () {
      revealActiveThumbs(document, true);
    },
    { once: true }
  );

  // Klaviyo teaser ("Get Early Access"): on phones and tablets assets/bfcm-product.css turns it into a vertical
  // tab. Klaviyo centres the label with no-break spaces, which would push it off-centre in the tab, so while the
  // tab shows they become ordinary spaces, which collapse. Wider (or after turning a tablet) the text goes back.
  function tidyTeaserLabels() {
    document.querySelectorAll('div[class*="kl-teaser-"] [id^="rich-text-"]').forEach(function (label) {
      var tab = getComputedStyle(label).writingMode.indexOf('vertical') === 0;
      var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      for (var node = walker.nextNode(); node; node = walker.nextNode()) {
        if (tab && node.data.indexOf('\u00a0') !== -1) {
          node.bfcmTeaserText = node.data;
          node.data = node.data.replace(/\u00a0/g, ' ');
        } else if (!tab && node.bfcmTeaserText != null) {
          node.data = node.bfcmTeaserText;
          node.bfcmTeaserText = null;
        }
      }
    });
  }

  if (document.body.classList.contains('template-product')) {
    var teaserQueued = false;
    var queueTeaserTidy = function () {
      if (teaserQueued) return;
      teaserQueued = true;
      requestAnimationFrame(function () {
        teaserQueued = false;
        tidyTeaserLabels();
      });
    };
    // Klaviyo adds the teaser when the popup closes and removes it when the popup opens
    new MutationObserver(queueTeaserTidy).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', queueTeaserTidy);
    queueTeaserTidy();
  }
})();
